var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4676_1729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6408 10.4643L20.9224 2H19.1969L12.8743 9.34942L7.82442 2H2L9.63638 13.1136L2 21.9897H3.72561L10.4025 14.2285L15.7355 21.9897H21.5599L13.6404 10.4643H13.6408ZM11.2773 13.2115L10.5036 12.1049L4.34737 3.29901H6.9978L11.966 10.4056L12.7397 11.5123L19.1977 20.7498H16.5473L11.2773 13.212V13.2115Z",
    fill: "#0B0A0B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4676_1729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.5599,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.140b20527bac418618a3b2da2273179d.svg";
export { ForwardRef as ReactComponent };